module.exports = __webpack_public_path__ + "assets/addtoany.61ada4e7.svg";